"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const adminClient_1 = require("src/client/adminClient");
const Dropdown_1 = __importDefault(require("src/components/design-system/dropdown/Dropdown"));
const Trigger_1 = __importDefault(require("src/components/design-system/dropdown/Trigger"));
const LoadingComponent_1 = __importDefault(require("src/components/shared/LoadingComponent"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs_1.default.extend(localizedFormat);
const dateFormatter = (start, end) => {
    return `${(0, dayjs_1.default)(start).format('HH.mm, D MMM YYYY')} - ${(0, dayjs_1.default)(end).format('HH.mm, D MMM YYYY')}`;
};
const LIMIT = 10;
const PulseSurveyDropdownOccurrences = ({ surveyId, selectedOccurrence, setSelectedOccurrence }) => {
    const currentPeriodText = selectedOccurrence &&
        dateFormatter(selectedOccurrence.startDate, selectedOccurrence.endDate);
    const changePeriodHandler = (data) => {
        setSelectedOccurrence(data);
    };
    return (react_1.default.createElement(Dropdown_1.default, null,
        react_1.default.createElement(Dropdown_1.default.Trigger, null,
            react_1.default.createElement(Trigger_1.default, { label: 'Period', text: currentPeriodText })),
        selectedOccurrence ? (react_1.default.createElement(DropdownContent, { selectedOccurrence: selectedOccurrence, surveyId: surveyId, changePeriodHandler: changePeriodHandler })) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
const DropdownContent = ({ selectedOccurrence, changePeriodHandler, surveyId }) => {
    const [defaultOccurrence] = (0, react_1.useState)(selectedOccurrence);
    const [ocurrenceLists, setOcurrenceLists] = (0, react_1.useState)([]);
    const [firstOccurrenceId] = (0, react_1.useState)(selectedOccurrence === null || selectedOccurrence === void 0 ? void 0 : selectedOccurrence.id);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const [loadingRef, setLoadingRef] = (0, react_1.useState)(null);
    const fetchOccurrence = (pageParams) => {
        const params = {
            olderThan: pageParams === null || pageParams === void 0 ? void 0 : pageParams.olderThan,
            state: ['current', 'past']
            // excludes: firstOccurrenceId, --> disable paginate #1
            // limit: LIMIT
        };
        return (0, adminClient_1.getSurveyOccurencesPerId)(surveyId, params);
    };
    const queryKey = ['occurrence-dropdown', surveyId, firstOccurrenceId];
    const { data: surveyDatas, isSuccess, isFetching, fetchNextPage } = (0, react_query_1.useInfiniteQuery)(queryKey, ({ pageParam }) => fetchOccurrence(pageParam), {
        getNextPageParam: (lastPage) => { var _a; return ((_a = lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) || 0; },
        staleTime: 500
    });
    const checkHasMore = (pages) => {
        var _a, _b;
        const currentIndex = pages.length - 1;
        const currentPage = pages === null || pages === void 0 ? void 0 : pages[currentIndex];
        if (!currentPage || !(currentPage === null || currentPage === void 0 ? void 0 : currentPage.isSuccess))
            return;
        const currentData = currentPage.data;
        const nextPageParams = (_b = (_a = currentPage === null || currentPage === void 0 ? void 0 : currentPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan;
        setHasMore(currentData.length == LIMIT && nextPageParams);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!isSuccess && !surveyDatas)
            return;
        if (!isFetching && surveyDatas) {
            checkHasMore(surveyDatas === null || surveyDatas === void 0 ? void 0 : surveyDatas.pages);
            const newObj = (0, flatten_1.default)((_a = surveyDatas === null || surveyDatas === void 0 ? void 0 : surveyDatas.pages) === null || _a === void 0 ? void 0 : _a.map((page) => {
                var _a;
                if (page === null || page === void 0 ? void 0 : page.data) {
                    return (_a = page === null || page === void 0 ? void 0 : page.data) === null || _a === void 0 ? void 0 : _a.map((d) => {
                        return d;
                    });
                }
            })).filter((data) => data);
            // setOcurrenceLists([defaultOccurrence, ...newObj]); --> disable paginate #2
            setOcurrenceLists([...newObj]);
        }
    }, [surveyDatas, isSuccess, isFetching, defaultOccurrence]);
    (0, react_1.useEffect)(() => {
        if (!loadingRef)
            return;
        const targetEl = loadingRef;
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => __awaiter(void 0, void 0, void 0, function* () {
                if (entry.isIntersecting && hasMore && !isFetching) {
                    yield fetchNextPage();
                }
            }));
        }, options);
        observer.observe(targetEl);
        return () => {
            observer.disconnect();
        };
    }, [loadingRef, hasMore, isFetching, fetchNextPage]);
    return (react_1.default.createElement(Dropdown_1.default.MenuItems, { type: "absolute", position: "right", useScrollClose: true, maxHeight: 300, customContainerClass: "w-[310px]" },
        react_1.default.createElement(react_1.default.Fragment, null, ocurrenceLists === null || ocurrenceLists === void 0 ? void 0 :
            ocurrenceLists.map((data) => (react_1.default.createElement(Dropdown_1.default.MenuItem, { key: data.id, onClick: () => changePeriodHandler(data), customClass: `justify-end ${data.id == selectedOccurrence.id ? '!bg-base-30024' : ''}` },
                react_1.default.createElement("p", { className: "flex justify-end w-full" }, dateFormatter(data.startDate, data.endDate))))),
            isFetching && react_1.default.createElement(LoadingComponent_1.default, null),
            react_1.default.createElement("div", { ref: (ref) => setLoadingRef(ref) }))));
};
exports.default = PulseSurveyDropdownOccurrences;
